import React, { useState } from 'react';
import { FileText, ChevronLeft, Upload, X, Check, FolderPlus, Folder } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AddDocument() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState('');
  const [documentTitle, setDocumentTitle] = useState('');
  const [documentDescription, setDocumentDescription] = useState('');
  const [tags, setTags] = useState<string[]>([]);
  const [newTag, setNewTag] = useState('');
  const [uploadComplete, setUploadComplete] = useState(false);
  const folders = [{
    id: 1,
    name: 'Committee Charters'
  }, {
    id: 2,
    name: 'Meeting Minutes'
  }, {
    id: 3,
    name: 'Policies & Procedures'
  }, {
    id: 4,
    name: 'Reports & Presentations'
  }];
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      // Auto-populate title with file name (minus extension)
      const fileName = e.target.files[0].name;
      setDocumentTitle(fileName.substring(0, fileName.lastIndexOf('.')));
    }
  };
  const handleAddTag = () => {
    if (newTag && !tags.includes(newTag)) {
      setTags([...tags, newTag]);
      setNewTag('');
    }
  };
  const handleRemoveTag = (tagToRemove: string) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedFile) return;
    // Simulate file upload
    setUploading(true);
    const interval = setInterval(() => {
      setUploadProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setUploading(false);
          setUploadComplete(true);
          return 100;
        }
        return prev + 10;
      });
    }, 300);
  };
  const getFileIcon = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return <FileText size={20} className="text-red-500" data-id="element-1059" />;
      case 'doc':
      case 'docx':
        return <FileText size={20} className="text-blue-500" data-id="element-1060" />;
      case 'xls':
      case 'xlsx':
        return <FileText size={20} className="text-green-500" data-id="element-1061" />;
      case 'ppt':
      case 'pptx':
        return <FileText size={20} className="text-orange-500" data-id="element-1062" />;
      default:
        return <FileText size={20} className="text-gray-500" data-id="element-1063" />;
    }
  };
  return <div data-id="element-1064">
      <div className="flex items-center mb-6" data-id="element-1065">
        <Link to="/documents" className="flex items-center text-gray-600 hover:text-gray-900 mr-4" data-id="element-1066">
          <ChevronLeft size={20} className="mr-1" data-id="element-1067" />
          Back to Documents
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-1068">Upload Document</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1069">
        <form onSubmit={handleSubmit} data-id="element-1070">
          <div className="space-y-6" data-id="element-1071">
            {/* File Upload Area */}
            <div data-id="element-1072">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1073">
                Select File <span className="text-red-500" data-id="element-1074">*</span>
              </label>
              {!selectedFile ? <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center" data-id="element-1075">
                  <Upload size={40} className="mx-auto text-gray-400 mb-4" data-id="element-1076" />
                  <p className="text-gray-500 mb-2" data-id="element-1077">
                    Drag and drop file here, or click to browse
                  </p>
                  <p className="text-xs text-gray-400 mb-4" data-id="element-1078">
                    Supported formats: PDF, DOCX, XLSX, PPTX, JPG, PNG (Max
                    20MB)
                  </p>
                  <input type="file" id="file-upload" className="hidden" onChange={handleFileSelect} data-id="element-1079" />
                  <label htmlFor="file-upload" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors cursor-pointer" data-id="element-1080">
                    Browse Files
                  </label>
                </div> : <div className="border border-gray-300 rounded-lg p-4" data-id="element-1081">
                  <div className="flex items-center justify-between mb-2" data-id="element-1082">
                    <div className="flex items-center" data-id="element-1083">
                      {getFileIcon(selectedFile.name)}
                      <span className="ml-2 font-medium" data-id="element-1084">
                        {selectedFile.name}
                      </span>
                      <span className="ml-2 text-xs text-gray-500" data-id="element-1085">
                        {(selectedFile.size / (1024 * 1024)).toFixed(2)} MB
                      </span>
                    </div>
                    <button type="button" className="text-gray-400 hover:text-red-500" onClick={() => {
                  setSelectedFile(null);
                  setUploadProgress(0);
                  setUploading(false);
                  setUploadComplete(false);
                }} data-id="element-1086">
                      <X size={18} data-id="element-1087" />
                    </button>
                  </div>
                  {uploading && <div data-id="element-1088">
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-1089">
                        <div className="h-2.5 rounded-full bg-orange-500" style={{
                    width: `${uploadProgress}%`
                  }} data-id="element-1090"></div>
                      </div>
                      <div className="flex justify-between text-xs text-gray-500" data-id="element-1091">
                        <span data-id="element-1092">Uploading...</span>
                        <span data-id="element-1093">{uploadProgress}%</span>
                      </div>
                    </div>}
                  {uploadComplete && <div className="flex items-center text-green-500 text-sm" data-id="element-1094">
                      <Check size={16} className="mr-1" data-id="element-1095" />
                      Upload complete
                    </div>}
                </div>}
            </div>
            {/* Document Details */}
            <div data-id="element-1096">
              <h3 className="text-lg font-medium mb-4" data-id="element-1097">Document Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1098">
                {/* Document Title */}
                <div className="md:col-span-2" data-id="element-1099">
                  <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1100">
                    Document Title <span className="text-red-500" data-id="element-1101">*</span>
                  </label>
                  <input type="text" id="title" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={documentTitle} onChange={e => setDocumentTitle(e.target.value)} required data-id="element-1102" />
                </div>
                {/* Folder Selection */}
                <div data-id="element-1103">
                  <label htmlFor="folder" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1104">
                    Folder <span className="text-red-500" data-id="element-1105">*</span>
                  </label>
                  <div className="relative" data-id="element-1106">
                    <select id="folder" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" value={selectedFolder} onChange={e => setSelectedFolder(e.target.value)} required data-id="element-1107">
                      <option value="" data-id="element-1108">Select Folder</option>
                      {folders.map(folder => <option key={folder.id} value={folder.name} data-id="element-1109">
                          {folder.name}
                        </option>)}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1110">
                      <Folder size={18} className="text-gray-400" data-id="element-1111" />
                    </div>
                  </div>
                </div>
                {/* New Folder Option */}
                <div data-id="element-1112">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1113">
                    Or Create New Folder
                  </label>
                  <div className="flex" data-id="element-1114">
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="New folder name" data-id="element-1115" />
                    <button type="button" className="px-4 py-2 bg-orange-500 text-white rounded-r-md hover:bg-orange-600 transition-colors" data-id="element-1116">
                      <FolderPlus size={18} data-id="element-1117" />
                    </button>
                  </div>
                </div>
                {/* Document Description */}
                <div className="md:col-span-2" data-id="element-1118">
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1119">
                    Description
                  </label>
                  <textarea id="description" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={documentDescription} onChange={e => setDocumentDescription(e.target.value)} placeholder="Enter a brief description of the document" data-id="element-1120"></textarea>
                </div>
                {/* Tags */}
                <div className="md:col-span-2" data-id="element-1121">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1122">
                    Tags
                  </label>
                  <div className="flex flex-wrap gap-2 mb-2" data-id="element-1123">
                    {tags.map(tag => <div key={tag} className="flex items-center bg-gray-100 px-3 py-1 rounded-full" data-id="element-1124">
                        <span className="text-sm" data-id="element-1125">{tag}</span>
                        <button type="button" className="ml-1 text-gray-400 hover:text-red-500" onClick={() => handleRemoveTag(tag)} data-id="element-1126">
                          <X size={14} data-id="element-1127" />
                        </button>
                      </div>)}
                  </div>
                  <div className="flex" data-id="element-1128">
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="Add a tag" value={newTag} onChange={e => setNewTag(e.target.value)} onKeyPress={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddTag();
                    }
                  }} data-id="element-1129" />
                    <button type="button" className="px-4 py-2 bg-orange-500 text-white rounded-r-md hover:bg-orange-600 transition-colors" onClick={handleAddTag} data-id="element-1130">
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Access Control - Optional section */}
            <div data-id="element-1131">
              <h3 className="text-lg font-medium mb-4" data-id="element-1132">Access Control</h3>
              <div className="space-y-4" data-id="element-1133">
                <div data-id="element-1134">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1135">
                    Visibility
                  </label>
                  <div className="flex space-x-4" data-id="element-1136">
                    <label className="flex items-center" data-id="element-1137">
                      <input type="radio" name="visibility" value="public" defaultChecked className="mr-2" data-id="element-1138" />
                      Public (All committee members)
                    </label>
                    <label className="flex items-center" data-id="element-1139">
                      <input type="radio" name="visibility" value="private" className="mr-2" data-id="element-1140" />
                      Private (Selected members only)
                    </label>
                  </div>
                </div>
                <div data-id="element-1141">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1142">
                    Committee
                  </label>
                  <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1143">
                    <option value="" data-id="element-1144">All Committees</option>
                    <option value="finance" data-id="element-1145">Finance Committee</option>
                    <option value="hr" data-id="element-1146">HR Committee</option>
                    <option value="it" data-id="element-1147">IT Committee</option>
                    <option value="procurement" data-id="element-1148">Procurement Committee</option>
                    <option value="quality" data-id="element-1149">Quality Assurance Committee</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Submit Buttons */}
            <div className="flex justify-end space-x-3 pt-4" data-id="element-1150">
              <Link to="/documents" className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-1151">
                Cancel
              </Link>
              <button type="submit" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" disabled={!selectedFile || uploading} data-id="element-1152">
                <Upload size={18} className="inline mr-2" data-id="element-1153" />
                Upload Document
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
}